import { useEffect } from 'react'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import {
  customerTypeFilter,
  customerTypeFilterSelection,
  defaultCustomerTypeSelection,
} from 'app/dataProviders/filter-items'
import { CustomerType } from 'app/dataTypes/reports/customersType'

type Props = {
  id: string
  pending: boolean
}

export const getCustomerTypeData = () => {
  return [
    { id: CustomerType.Students, title: 'Учащиеся' },
    { id: CustomerType.Employees, title: 'Сотрудники' },
  ]
}

export const CustomerTypeFilter = ({ id, pending }: Props) => {
  useEffect(() => {
    customerTypeFilter.updateData(getCustomerTypeData)
    customerTypeFilter.setStatusReady()
    customerTypeFilterSelection.updateData(() => [])
  }, [])

  return (
    <PlainItemsSelectorBox
      id={id}
      label="Тип покупателя"
      header="Выбор типа покупателя"
      dataBoxData={customerTypeFilter}
      dataBoxSelection={customerTypeFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      disabled={pending}
      multiple
      defaultSelection={defaultCustomerTypeSelection}
    />
  )
}
